import { render } from "./ThePriceCompetitorInfo.vue?vue&type=template&id=eae704ca&scoped=true"
import script from "./ThePriceCompetitorInfo.vue?vue&type=script&lang=js"
export * from "./ThePriceCompetitorInfo.vue?vue&type=script&lang=js"

import "./ThePriceCompetitorInfo.vue?vue&type=style&index=0&id=eae704ca&scoped=true&lang=css"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eae704ca"]])

export default __exports__